import * as yup from 'yup';
import { COUNTRY_CODES } from '@/utils/countries';

const optionalText = yup
  .string()
  .transform((value) => (value === '' ? null : value))
  .nullable()
  .optional();

export const legalEntitySchema = yup.object({
  name: yup.string().required(),
  street: yup.string().required(),
  zip: yup.string().required(),
  /** Per document language; Spanish documents fall back to English. */
  city: yup.object({
    de: yup.string().required(),
    en: yup.string().required(),
    es: yup.string().optional(),
  }),
  countryCode: yup
    .string()
    .oneOf([...COUNTRY_CODES])
    .required(),
  localLanguage: yup
    .string()
    .matches(/^[a-z]{2}$/)
    .required(),
  email: yup.string().email().required(),
  phone: yup.string().trim().required(),
  website: yup.string().trim().url().required(),
  vatId: yup.string().trim().required(),
  taxNumber: optionalText,
  commercialRegister: yup.string().trim().required(),
  managingDirectors: yup.string().trim().required(),
  iban: yup.string().trim().required(),
  bic: yup.string().trim().required(),
  bankName: yup.string().trim().required(),
  /** Without it the legal entity cannot collect SEPA direct debits. */
  sepaCreditorId: optionalText,
  adyenMerchantAccount: yup.string().trim().required(),
  invoiceNumberPrefix: yup
    .string()
    .max(5)
    .matches(/^[A-Z0-9-]*$/)
    .default(''),
  localTerms: yup.string().trim().required(),
  englishTerms: yup.string().trim().required(),
  isActive: yup.boolean().required(),
  /** EU One-Stop Shop: bookings are taxed in the country of supply instead of the home country. */
  isOssRegistered: yup.boolean().required(),
});
